import ButtonDropdown from '@pelckmans/elementis/components/button-dropdown';
import Button, { ButtonProps } from '@pelckmans/elementis/components/button';
import PlusIcon from '@pelckmans/elementis/icons/plus';
import { Dispatch, SetStateAction, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ModalContext from '../../../contexts/ModalContext';
import AddPersonalGroupModal from '../modals/add-personal-group/AddPersonalGroupModal';
import { SchoolYear } from '../context/MyGroupsContext';
import AccountContext from '../../../contexts/AccountContext';
import { Group } from '../../../api/groups';

type Props = {
  schoolYear: SchoolYear;
  onGroupsChange: Dispatch<SetStateAction<Group[] | undefined>>;
  size: ButtonProps['size'];
};

function AddGroupButton({ schoolYear, onGroupsChange, size }: Props) {
  const { t } = useTranslation();

  const {
    account: { oauthIdentities },
  } = useContext(AccountContext);

  const hasCoupledSmartschoolAccount = useMemo(() => {
    const hasSmartschoolIdentity = Boolean(oauthIdentities?.some(x => x.provider === 'smartschool'));

    return ['SO', 'ES'].includes(process.env.REACT_APP_P_STUDIO_GROUP) && hasSmartschoolIdentity;
  }, [oauthIdentities]);

  const { showModal } = useContext(ModalContext);

  const openAddPersonalGroupModal = () => {
    showModal(
      <AddPersonalGroupModal id="add-personal-group-modal" schoolYear={schoolYear} onGroupsChange={onGroupsChange} />,
    );
  };

  if (hasCoupledSmartschoolAccount) {
    return (
      <ButtonDropdown
        buttonProps={{ prominence: 'secondary' }}
        title={t('PAGES.MY_GROUPS.ADD_GROUP.BUTTON_DROPDOWN.TITLE')}
        size={size}
      >
        <ButtonDropdown.Item
          onClick={openAddPersonalGroupModal}
          value="personal"
          text={t('PAGES.MY_GROUPS.ADD_GROUP.BUTTON_DROPDOWN.ITEMS.PERSONAL_GROUP')}
        />
      </ButtonDropdown>
    );
  }

  return (
    <Button onClick={openAddPersonalGroupModal} prominence="secondary" startIcon={<PlusIcon />} size={size}>
      {t('PAGES.MY_GROUPS.ADD_GROUP.BUTTON_DROPDOWN.TITLE')}
    </Button>
  );
}

export default AddGroupButton;
